import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../global/util/Constant';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {TemporarySessionService} from '../../../user/service/temporary-session.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {InstallerService} from '../../../user/service/installer.service';
import {OperatingSystem} from '../../../global/util/OperatingSystem';

@Component({
  selector: 'app-view-observation-cancel',
  templateUrl: './component-verification.component.html',
  styleUrls: ['./component-verification.component.css']
})
export class ComponentVerificationComponent implements OnInit {

  public title = 'TITLE.VERIFICATION-SIGNATURE-COMPONENT';
  public description: any;
  public question: string;
  public loading = false;
  public verified = false;
  public showDownloadButton = false;
  public os: string;
  public WINDOWS = OperatingSystem.Windows;

  constructor(public installerService: InstallerService,
              public activeModal: NgbActiveModal,
              private route: Router,
              private temporarySessionService: TemporarySessionService,
              private translate: TranslateService) {
  }

  ngOnInit() {
  }

  public accept() {
    this.loading = true;
    const uuid = localStorage.getItem('uuidv1');
    const src = 'rsign:?installation_verification_callback='.concat(
      Constant.ROOT_API_V1,
      '/public/rccomponents/temporarysessions/',
      uuid,
      '/save');
    window.open(src, '_self');
    this.checkInstalledComponent(uuid);
  }

  public cancel() {
    this.activeModal.close();
  }

  public isNotMacOs(): boolean {
    return this.os !== this.WINDOWS;
  }

  public download() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/installers/signatureapplication/', String(6), '/stream');
    this.installerService.getOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      const today = LocalStorage.getTodayString();
      const filename = 'RV-DSignature-app-SNAPSHOT.exe';
      control.download = filename;
      control.click();
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  public checkInstalledComponent(uuid: string) {
    const urlOne2One = Constant.ROOT_API_V1.concat('/public/temporarysessions/', uuid, '/verification');
    this.loading = true;
    const interval = setInterval(() => {
      this.temporarySessionService.get(urlOne2One).subscribe((next: any) => {
        if (next === true) {
          this.description = this.translate.instant('MESSAGE.YOU-HAVE-SIGNATURE-COMPONENT-INSTALLED');
        } else{
          this.showDownloadButton = true;
        }
        this.verified = true;
        this.loading = false;
        clearInterval(interval);
      }, error => {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-SIGNATURE-COMPONENT'), error.error.message);
      });
    }, 10000);
  }
}
